// extracted by mini-css-extract-plugin
export default {"container":"container--mp-lmR74","icon":"icon--mp-kzlLb","body":"body--mp-y19I2","title":"title--mp-XQABC"};